import angular from 'angular';
import TicketsWidgetComponent from './tickets-widget-component';

export default angular.module('tickets-widget', []).component('ticketsWidget', new TicketsWidgetComponent());



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/tickets/tickets-widget-module.js